var React = require('react');

function Russia (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M44 0H4a4 4 0 00-4 4v8a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4z","key":0}),React.createElement("path",{"fill":"#D52B1E","d":"M44 16H4a4 4 0 00-4 4v8a4 4 0 004 4h40a4 4 0 004-4v-8a4 4 0 00-4-4z","key":1}),React.createElement("path",{"fill":"#0039A6","d":"M48 10.7H0v10.6h48V10.7z","key":2})]);
}

Russia.defaultProps = {"fill":"none","viewBox":"0 0 48 32"};

module.exports = Russia;

Russia.default = Russia;
